import { Requirement } from '../../../models';
import { CHART_COLORS } from '../../../../globalStyle/colors';
import { RingConfig } from '../../../../loading/ProgressCircle';
import { loopIndex } from '../../../../language/arrays';


/**
 * Sums the total number of completed surveys
 */
export const sumCompleted = (
  requirements: Requirement[] | undefined,
): number => requirements?.reduce((running, next) => running + next.completedCount, 0) ?? 0;


export const getSurveyLevelColor = loopIndex(CHART_COLORS.LEVELS);


export const mapRingConfig = (completed: number, requirements: Requirement[] | undefined): RingConfig[] => {
  if (!requirements || completed === 0) {
    return [{ name: 'None Completed', progress: 0, color: 'transparent' }];
  }

  return requirements.reduce(
    (running, next, i) => ({
      sum:    running.sum + next.completedCount,
      config: running.config.concat({
        name:     next.fullName,
        progress: (next.completedCount + running.sum) / completed,
        color:    getSurveyLevelColor(i),
      }),
    }),
    { sum: 0, config: [] as RingConfig[] },
  ).config;
};
